import React, { memo } from 'react';
import './PowerStatusMessage.scss';

function PowerStatusMessage(props) {
  const { message, imgIcon, view, showUploadPrescModal, dataLocale, powerValue, isBorderallowed } = props;
  return (
    <div className={view !== 'desktop' ? 'padding_0_7' : ''}>
      {view !== 'desktop' && isBorderallowed && <div className="border-bottom_grey mr-l8 mr-r8"></div>}
      <div
        data-testid="powerStatusMessage"
        className={`power-status-message display-flex align-items-center ${view === 'desktop'
          ? 'desktop padding-12 margin-l15 margin-b10 margin-t10 bora-8 mr-t5'
          : 'pd-b10 bora-4 mr-auto pd-t10 width_100 pd-l8 pd-r8'
          }`}
      >
        {view === 'desktop' && <div className="status-icon mr-r12 margin-r12" id={imgIcon}>
          <span className="icon display-flex align-items-center test-color_white justify-content-center fsp18 fs18">
            <img aria-label="Power Status Icon" src={imgIcon} alt="Power status icon" />
          </span>
        </div>}
        {!powerValue ? (
          <div className={`status-message fsp12 lh-16 ${view === 'desktop' ? 'display-flex align-items-center flex-1' : ''}`}>
            {message} {typeof showUploadPrescModal === 'function' && view !== 'desktop' && <span className="mr-l8 fsp12 text-color_link_blue text-uppercase fw400 align-self-center" onClick={showUploadPrescModal}>{dataLocale?.VIEW_PRESCRIPTION}</span>}
          </div>
        ) : (
          <div className="status-message fsp12 lh-16 display-flex align-items-center flex-1">
            {view === 'desktop' ? dataLocale?.POWER_PRESCRIPTION_UPLOADED : dataLocale?.PRESCRIPTION_UPLOADED} {typeof showUploadPrescModal === 'function' && view !== 'desktop' && <span className="mr-l8 fsp12 text-color_link_blue text-uppercase fw400 align-self-center" onClick={showUploadPrescModal}>{dataLocale?.VIEW_PRESCRIPTION}</span>}
          </div>
        )}
        {typeof showUploadPrescModal === 'function' && view === 'desktop' && (
          <div
            className='text-color-primary cursor-pointer margin-r20 uppercase fw700 align-self-center'
            onClick={showUploadPrescModal}
          >
            {dataLocale?.VIEW_DETAILS}
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(PowerStatusMessage);
